import { API, graphqlOperation, Auth } from "aws-amplify";
import {
  createUser,
  updateUser,
  deleteUser,
  createTenant,
  deleteTenant,
} from "./graphql/mutations";
import { buildInputObject, buildTenantInput } from "./utils/validators";

import {CheckIfEmailExists} from './graphql/queries'


const extractErrorMessage = (errorResponse) => {

  if (errorResponse?.errors?.length > 0) {
    return errorResponse.errors[0].message;
  }

  const name = errorResponse?.name;
  const message = errorResponse?.message || "";

  if (name === "InvalidPasswordException") {
    return "Password does not meet the security requirements. Please use a longer password with a mix of letters, numbers, and symbols.";
  }

  if (name === "UsernameExistsException") {
    return "An account with this email already exists. Please use a different email or try resetting your password.";
  }

  return message || "An unknown error occurred during registration.";
};


const handleCreateUser = async (formData, tenantData) => {
  let input;
  let createdUser;
  let cognitoUser;
  let createdTenant;

  try {
    input = await buildInputObject(formData);
  } catch (validationError) {
    throw new Error(extractErrorMessage(validationError));
  }

  try {
    const response = await API.graphql(graphqlOperation(createUser, { input }));
    createdUser = response.data.createUser;

    cognitoUser = await Auth.signUp({
      username: input.mail,
      password: input.pass,
      attributes: { email: input.mail },
    });

    await API.graphql(
      graphqlOperation(updateUser, {
        input: { id: createdUser.id, cognitoID: cognitoUser.userSub },
      })
    );

    // create a Tenant right after creating the User
    if (tenantData) {
      try {
        const tenantInput = await buildTenantInput(tenantData);
        const tenantResp = await API.graphql(
          graphqlOperation(createTenant, { input: tenantInput })
        );
        createdTenant = tenantResp.data.createTenant;
      } catch (tenantError) {
        throw tenantError;
      }
    }

    // After successful user and optional tenant creation, send minimal data to Google Sheets API
    try {
      const sheetsEndpoint = process.env.REACT_APP_SHEETS_ENDPOINT;
      const sheetsApiToken = process.env.REACT_APP_SHEETS_API_TOKEN;
      const sheetsApiKey = process.env.REACT_APP_SHEETS_API_KEY; 
      if (sheetsEndpoint && sheetsApiToken) {
        const headers = {
          "Content-Type": "application/json",
          "x-api-token": sheetsApiToken,
        };
        if (sheetsApiKey) {
          headers["x-api-key"] = sheetsApiKey;
        }

        const payload = {
          name: input?.name || '',
          email: input?.mail || '',
          phone: input?.phone || '',
          complexName: input?.comName || '',
          complexAddress: input?.comAddress || '',
          units: input?.comUnit || '',
          complexEmail: input?.comMail || '',
          complexPhone: input?.comPhone || '',
          gateType: input?.gate || '',
          parkingSpots: input?.pSpot || '',
          tenantParking: input?.pNumber || '',
          guestParking: input?.pNumGuest || '',
          adminParking: input?.pAdmin || '',
          handicapParking: input?.pHandcap || '',
          parkingSystem: input?.pSystem || '',
        };

        const resp = await fetch(sheetsEndpoint, {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        });

        if (!resp.ok) {
          await resp.text();
        }
      }
    } catch (sheetsError) {
    }

    return createdUser;
  } catch (error) {
    console.error("Error:", error);
    const errorMessage = extractErrorMessage(error);

    if (createdUser) {
      try {
        await API.graphql(
          graphqlOperation(deleteUser, { input: { id: createdUser.id } })
        );
      } catch (deleteError) {
        console.error(
          "Failed to rollback user creation in database:",
          deleteError
        );
      }
    }

    if (createdTenant) {
      try {
        await API.graphql(
          graphqlOperation(deleteTenant, { input: { id: createdTenant.id } })
        );
      } catch (deleteTenantError) {
        console.error(
          "Failed to rollback tenant creation in database:",
          deleteTenantError
        );
      }
    }

    if (cognitoUser) {
      try {
        await Auth.adminDeleteUser({
          Username: input.mail,
          UserPoolId: "us-east-1_envCctF4r",
        });
      } catch (deleteError) {
        console.error("Failed to rollback user in Cognito:", deleteError);
      }
    }

    throw errorMessage;
  }
};

 const  checkEmailExist=async (email)=> {
  const result = await API.graphql(graphqlOperation(CheckIfEmailExists, {
    email: email
  }));

  return result.data.listUsers.items.length > 0;
} 

export {
  handleCreateUser,
  checkEmailExist
}

